document.querySelectorAll('.mega-menu').forEach(menu => {
  menu.addEventListener('mouseenter', () => {
    menu.setAttribute('open', '');
  });
  
  menu.addEventListener('mouseleave', () => {
    setTimeout(() => {
      if (!menu.matches(':hover')) {
        menu.removeAttribute('open');
      }
    }, 100);
  });
});